import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import HeaderGroup, { HeaderGroupProps } from '../HeaderGroup'
import DropdownTree from '../Form/DropdownTree'
import { createPortal } from 'react-dom'
import type { DataNode } from 'antd/es/tree'
import SimpleDropdown from '../Form/SimpleDropdown'

type IProps = {
    data: {
        portalId?: string
        loading?: boolean
        icon: string
        title: string
        description: string
        actions?: { url: string; icon: string; title: string }[]
        checkeds?: React.Key[]
        treeData?: DataNode[]
        items?: HeaderGroupProps[]
        applyTreeCallback?(keys: React.Key[]): void
    }
}

const Header1 = ({ data }: IProps) => {
    const Render = (): JSX.Element => {
        return (
            <Content>
                <Item>
                    <WrapperIcon>
                        <i className={data?.icon || 'far fa-route'} />
                    </WrapperIcon>
                </Item>

                <Item ref={dropdownPortalRef} style={{ width: 400, display: 'flex' }}>
                    <DropdownTree
                        title={data?.title}
                        description={data?.description}
                        data={data?.treeData}
                        apply={data?.applyTreeCallback}
                        checkeds={data?.checkeds}
                    />
                </Item>

                <Item style={{ flex: 1 }}>
                    <WrapperHeaderGroup>
                        {data?.items?.map(({ title, subtitle, info = '', percentage, growth }, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', flex: 1 }}>
                                    <HeaderGroup
                                        title={title}
                                        subtitle={subtitle}
                                        info={info}
                                        percentage={percentage}
                                        growth={growth}
                                    />
                                    {index < data.items.length - 1 && <Separator />}
                                </div>
                            )
                        })}
                    </WrapperHeaderGroup>
                </Item>

                <Item>
                    <SimpleDropdown icon="far fa-ellipsis-v" data={data?.actions} />
                </Item>
            </Content>
        )
    }

    useEffect(() => {
        if (data?.portalId) {
            const aux = document.getElementsByClassName(data?.portalId)
            if (aux) {
                setPortal(aux[0])
            }
        }
    }, [data?.portalId])

    const dropdownPortalRef = useRef(null)
    const [portal, setPortal] = useState<any>()

    return (
        <Wrapper>
            {data?.loading != false ? (
                <div className="loading" />
            ) : (
                <>{portal ? createPortal(<Render />, portal) : <Render />}</>
            )}
        </Wrapper>
    )
}

export default Header1

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
`

const Separator = styled.div`
    height: 100%;
    width: 1.5px;
    margin: 0 auto;
    background: ${({ theme }) => theme['gray-200']};
`

const Content = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    top: 10px;
    width: 100%;
    padding: 0 16px;
    gap: 8px;
`

const WrapperHeaderGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: end;
    height: 58px;
    font-family: ${({ theme }) => theme['font-semibold']};
`

const Item = styled.div``

const WrapperIcon = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    font-size: 22px;
    font-weight: 400;
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-700']};
`
